import { IStickerPack } from '@livelike/javascript';
import { createStore } from './store';

const initialStickerPack: IStickerPack[] = [];

export const stickerPackStore = createStore(initialStickerPack);

export const stickerPackStoreActions = {
  updateStickerPacksAction(stickerPacks: IStickerPack[]) {
    stickerPackStore.set(stickerPacks);
  },
};
